/** Avoid Redux churn when JWT-backed Me payload is unchanged. */
export const authUserSnapshotEqual = (a: any, b: any): boolean => {
    if (!a || !b) {
        return false;
    }
    if (a.email !== b.email || a.currencyCode !== b.currencyCode || a.showUsSizes !== b.showUsSizes) {
        return false;
    }
    if (JSON.stringify(a.disallowedTypes) !== JSON.stringify(b.disallowedTypes)) {
        return false;
    }
    return JSON.stringify(a.customerData) === JSON.stringify(b.customerData);
};
